/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRarIcon24Solid = forwardRef('GovKoRarIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.098.08a.434.434 0 0 0-.397.397 5.5 5.5 0 0 0 5.943 5.944.434.434 0 0 0 .397-.398A5.5 5.5 0 0 0 6.098.08Z" }),
        React.createElement("path", { d: "M6.072 12.747a2.375 2.375 0 1 0 0-4.75 2.375 2.375 0 0 0 0 4.75Z" }),
        React.createElement("path", { d: "M14.375 10.372a2.375 2.375 0 1 1-4.75 0 2.375 2.375 0 0 1 4.75 0Z" }),
        React.createElement("path", { d: "M14.375 20.593a2.375 2.375 0 1 1-4.75 0 2.375 2.375 0 0 1 4.75 0Z" }),
        React.createElement("path", { d: "M20.304 10.372a2.375 2.375 0 1 1-4.75 0 2.375 2.375 0 0 1 4.75 0Z" }),
        React.createElement("path", { d: "M9.036 17.857a2.375 2.375 0 1 0 0-4.75 2.375 2.375 0 0 0 0 4.75Z" }),
        React.createElement("path", { d: "M17.34 15.482a2.375 2.375 0 1 1-4.75 0 2.375 2.375 0 0 1 4.75 0Z" })));
});
